import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
// import auth from "services/auth";
// import ls, { set } from "local-storage";
// import AppContext from "contexts/AppContext";
import api from "services/api";
import emailValidate from "services/emailValidate";
// import LanguageSwitcher from "elements/LanguageSwitcher";
import SupportSidebar from "elements/SupportSidebar";
import { __ } from "services/Translator";
import JackpotTicker from "elements/JackpotTicker";
// import validator from "validator";
import swal from "sweetalert";
import CMSModal from "elements/CMSModal";

import { Button } from "react-bootstrap";

const Footer = (props) => {
  // subcription

  const [errors, setErrors] = useState({});

  const validateForm = () => {
    var valid = true;
    // return valid;
    var errorsTmp = {};
    // alert(44);
    if (subData < 2 || subData > 250) {
      errorsTmp = { ...errorsTmp, email: __("Please enter your email") };
      valid = false;
    }

    setErrors(errorsTmp);
    return valid;
  };

  const [subData, setSubData] = useState("");

  const subAction = async (event) => {
    event.preventDefault();
    var valid = validateForm();
    if (valid) {
      // swal({
      //   title: __("Successfully subscribed !"),
      //   icon: "success",
      // });
      var response = await api.post("/newsletter-subscription", {
        subscribeEmail: subData,
      });
      if (response.status === 200) {
        swal({
          title: __("Successfully subscribed!"),
          icon: "success",
        });
      }
    }
  };

  // const __ = (text) => text;
  const [languages, setLanguages] = useState([]);
  const getLanguages = async () => {
    var response = await api.get("/languages");
    if (response.status === 200) {
      // setLanguages(
      //   response.data.map((val) => {
      //     return { label: val.language, value: val.code };
      //   })
      // );
      setLanguages(response.data);
    } else {
      props.showAlert(null, response.data.message);
    }
  };

  useEffect(() => {
    getLanguages();
    // setTimeout(() => {
    //   try {
    //     window.apg_fd182c80_f32b_4a62_a3d5_47644daba979.init();

    //     window.xcm_0fb5404e_463f_45b3_8268_7797d673d57b.init();
    //   } catch (ex) {}
    // }, 2000);
  }, []);

  const scrollToTop = () => {
    document
      .getElementById("mainContent")
      .scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <>
      <SupportSidebar {...props} />

      <footer>
        <section className={"footer " + props.landingType}>
          <div className="container-xxl container-xl">
            <div className="newsletter padding_bottom_30">
              <div className="row">
                <div className="col-lg-6 col-xl-4">
                  <div className="card_img">
                    <img
                      alt="game image"
                      src="https://chimpbytes.imgix.net/footer-card.png?&dpr=1&format=auto&auto=format&w=228&h=437&max-age=2629056"
                    />
                  </div>
                </div>
                <div className="col-lg-6 col-xl-4">
                  <div className="newsletter_title text-uppercase padding_bottom_30">
                    {__("# newsletter")}
                    <span className={"title_dash " + props.landingType}></span>
                  </div>

                  <div className="newsletter_title headline">
                    {__("Newsletter Signup")}
                  </div>
                  <div className="paragraph text-uppercase">
                    {__("Signup to our newsletter and always receive the latest news and bonuses!")}
                  </div>

                </div>
                <div className="col-lg-12 col-xl-4">
                  <div className="text-right margin_bottom_30">
                    <div className="newsletter_title">
                      {__("Back to Top")}

                      <a href="javascript:" onClick={scrollToTop}>
                        <span className="arrow_up">
                          {props.landingType === "casino" && (
                            <img
                              src={
                                require("../assets/images/new-landing/icons/arrow-top-home.png")
                              }
                              alt="Arrow Top Home"
                            />
                          )}
                          {props.landingType === "sport" && (
                            <img
                              src={
                                require("../assets/images/new-landing/icons/arrow-top-sport.png")
                              }
                              alt="Arrow Top Sport"
                            />
                          )}
                          {props.landingType === "poker" && (
                            <img
                              src={
                                require("../assets/images/new-landing/icons/arrow-top-poker.png")
                              }
                              alt="Arrow Top Poker"
                            />
                          )}
                          {props.landingType === "bingo" && (
                            <img
                              src={
                                require("../assets/images/new-landing/icons/arrow-top-yellow.png")
                              }
                              alt="Arrow Top Yellow"
                            />
                          )}
                        </span>
                      </a>
                    </div>
                  </div>
                  <form onSubmit={subAction}>
                    <div className="email_input">
                      <input
                        type="email"
                        placeholder="Your Email"
                        name="subscribeEmail"
                        className="inputbox form-control"
                        onChange={(ev) => {
                          var target = ev.target;
                          var field = target.name;
                          var value = target.value;
                          setSubData(value);
                        }}
                        value={subData}
                      />

                      <button
                        type="submit"
                        className={"subscribe_btn " + props.landingType}
                      >
                        {__("SUBSCRIBE")}
                      </button>
                    </div>
                    <div className="error_msg">{errors.email}</div>
                  </form>
                  <div className="social_menu margin_top_30">
                    <div className="social_text">{__("Social networks")} </div>
                    <div className="social_icons">
                      <a target="_blank" href="https://www.instagram.com">
                        <i className="fab fa-instagram"></i>
                      </a>
                      <Link to="#">
                        <i class="fab fa-linkedin-in"></i>
                      </Link>
                      <Link to="#">
                        <i class="fab fa-facebook-f"></i>
                      </Link>

                      <a target="_blank" href="https://twitter.com/">
                        <i className="fab fa-twitter"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="footer_links">
              <div className="row">
                <div className="col-6 col-sm-6 col-md-4 col-lg-2">
                  <div className="lists">
                    <Link className={"heading " + props.landingType} to="#">
                      {__("information")}
                    </Link>
                    <Link
                      onClick={() => {
                        props.setOpenCMSModal(true);
                        props.setOpenCMSModalTab("careers");
                        // setLegalTab("AML Policy");
                      }}
                    >
                      {__("Careers")}
                    </Link>
                    <Link
                      onClick={() => {
                        props.setOpenCMSModal(true);
                        props.setOpenCMSModalTab("investor_relation");
                        // setLegalTab("AML Policy");
                      }}
                    >
                      {__("Investor relation")}
                    </Link>
                    <Link
                      onClick={() => {
                        props.setOpenCMSModal(true);
                        props.setOpenCMSModalTab("about_us");
                        // setLegalTab("AML Policy");
                      }}
                    >
                      {__("About Joker Casino")}
                    </Link>
                    <Link to="/blogs"> {__("Blog")} </Link>
                  </div>
                </div>
                <div className="col-6 col-sm-6 col-md-4 col-lg-2">
                  <div className="lists">
                    <Link className={"heading " + props.landingType} to="#">
                      {__("Legal")}
                    </Link>
                    <Link to="/promotions"> {__("Promotions")} </Link>
                    <Link to="#">{__("Banking")}</Link>
                    <Link to="/vip"> {__("Loyalty & VIP")}</Link>
                    <Link to="/games/slots"> {__("Play Now")} </Link>
                  </div>
                </div>
                <div className="col-6 col-sm-6 col-md-4 col-lg-2">
                  <div className="lists">
                    <Link className={"heading " + props.landingType}>
                      {__("CUSTOMER CARE")}
                    </Link>
                    <Link
                      onClick={() => {
                        props.setIsChatVisible(false);
                        props.setSupportSidebarOpen(true);
                      }}
                    >
                      {__("FAQs")}
                    </Link>
                    <Link
                      onClick={() => {
                        props.setOpenCMSModal(true);
                        props.setOpenCMSModalTab("returns_policy");
                        // setLegalTab("AML Policy");
                      }}
                    >
                      {__("Returns Policy")}
                    </Link>

                    <Link
                      onClick={() => {
                        props.setOpenCMSModal(true);
                        props.setOpenCMSModalTab("aml_policy");
                        // setLegalTab("AML Policy");
                      }}
                    >
                      {__("AML Policy")}
                    </Link>
                    <Link
                      onClick={() => {
                        props.setOpenCMSModal(true);
                        props.setOpenCMSModalTab("responsible_gaming");
                        // setLegalTab("Responsible Gaming");
                      }}
                    >
                      {__("Responsible Gaming")}
                    </Link>
                    <Link
                      onClick={() => {
                        props.setOpenCMSModal(true);
                        props.setOpenCMSModalTab("terms_conditions");
                        // setLegalTab("Terms & conditions");
                      }}
                    >
                      {__("Terms & Conditions")}
                    </Link>
                  </div>
                </div>
                <div className="col-6 col-sm-6 col-md-4 col-lg-2">
                  <div className="lists">
                    <Link className={"heading " + props.landingType}>
                      {__("Contact us")}
                    </Link>
                    <Link> {__("E-mail")}</Link>
                    <Link className="white">info@jokercasino.com</Link>
                    <Link className="margin_top_15"> {__("Phone")}</Link>
                    <Link className="white">779-240-9608</Link>
                  </div>
                </div>
                <div className="col-12 col-sm-12 col-md-4 col-lg-4">
                  <div className="lists">
                    <Link className={"heading " + props.landingType}>
                      {__("Jackpot Total")}
                    </Link>
                    <JackpotTicker {...props} />
                    <ul className="supported_currency_list">
                      <li>
                        <span className="currency_icon">
                          <svg className="svg_icon">
                            <use xlinkHref={"/icons.svg#icon-currency-btc"} />
                          </svg>
                        </span>
                      </li>
                      <li>
                        <span className="currency_icon">
                          <svg className="svg_icon">
                            <use xlinkHref={"/icons.svg#icon-currency-eth"} />
                          </svg>
                        </span>
                      </li>
                      <li>
                        <span className="currency_icon">
                          <svg className="svg_icon">
                            <use xlinkHref={"/icons.svg#icon-currency-ltc"} />
                          </svg>
                        </span>
                      </li>
                      <li>
                        <span className="currency_icon">
                          <svg className="svg_icon">
                            <use xlinkHref={"/icons.svg#icon-currency-doge"} />
                          </svg>
                        </span>
                      </li>
                      <li>
                        <span className="currency_icon">
                          <svg className="svg_icon">
                            <use xlinkHref={"/icons.svg#icon-currency-usdt"} />
                          </svg>
                        </span>
                      </li>
                    </ul>
                    <div>
                      <img
                        className="other_mayment_logo"
                        src={
                          require("assets/images/footer/payment_methods.jpg")
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>

              <hr />
              {props.isMobileDeviceByViewPort && (
                <div className="license_area">
                  <div className="license_text">
                    {__(
                      "Joker Casino is operated by iRubix N.V., a company incorporated in Curacao with company registration number 154071 and having its registered address at Abraham de Veerstraat 9, Curacao. Joker Casino is licensed and regulated by the Gaming Authority of Curacao under license number GLH-OCCHKTW0710242017 . Chimp Bytes B.V. is registered in The Netherlands and is providing (credit) card payment services as an agent according to the service agreement concluded between iRubix N.V. and Chimp Bytes B.V. Skrill, Neteller, Paysafecard and Rapid Transfer transactions are processed by iRubix N.V."
                    )}
                  </div>
                  <div className="license_logo">
                    <div
                      className="curacao_license_area"
                      id="apg-fd182c80-f32b-4a62-a3d5-47644daba979"
                      data-apg-seal-id="fd182c80-f32b-4a62-a3d5-47644daba979"
                      data-apg-image-size="256"
                      data-apg-image-type="basic-light-large"
                    ></div>

                    <div
                      className="curacao_license_area"
                      id="xcm-0fb5404e-463f-45b3-8268-7797d673d57b"
                      data-xcm-seal-id="0fb5404e-463f-45b3-8268-7797d673d57b"
                      data-xcm-image-size="128"
                      data-xcm-image-type="basic-small"
                    ></div>
                  </div>
                  <div className="cryptocasinos_approved_logo">
                    <a target="_blank" href="">
                      <img
                        src={
                          require("assets/images/footer/cryptocasinos_approved_logo.svg")
                        }
                      />
                    </a>
                  </div>
                  {/* <div>
                    <img
                      style={{
                        maxWidth: "200px",
                        margin: "0 auto",
                        display: "block",
                      }}
                      src={
                        require("assets/images/footer/payment_methods.jpg")
                      }
                    />
                  </div> */}
                  <div className="footer_copyright_text">
                    Copyright © {new Date().getFullYear()} www.jokercasino.com -
                    All rights reserved.
                  </div>
                </div>
              )}

              {!props.isMobileDeviceByViewPort && (
                <div className="license_area">
                  {/* <div className="license_logo">
                    <div
                      className="curacao_license_area"
                      id="apg-fd182c80-f32b-4a62-a3d5-47644daba979"
                      data-apg-seal-id="fd182c80-f32b-4a62-a3d5-47644daba979"
                      data-apg-image-size="256"
                      data-apg-image-type="basic-light-large"
                    ></div>

                    <div
                      className="curacao_license_area"
                      id="xcm-0fb5404e-463f-45b3-8268-7797d673d57b"
                      data-xcm-seal-id="0fb5404e-463f-45b3-8268-7797d673d57b"
                      data-xcm-image-size="128"
                      data-xcm-image-type="basic-small"
                    ></div>
                  </div> */}
                  <div className="cryptocasinos_approved_logo">
                    <a target="_blank" href="">
                      <img
                        src={
                          require("assets/images/footer/cryptocasinos_approved_logo.svg").default
                        }
                      />
                    </a>
                  </div>
                  <div className="license_text">
                    {__(
                      "Joker Casino is operated by iRubix N.V., a company incorporated in Curacao with company registration number 154071 and having its registered address at Abraham de Veerstraat 9, Curacao. Joker Casino is licensed and regulated by the Gaming Authority of Curacao under license number GLH-OCCHKTW0710242017 . Chimp Bytes B.V. is registered in The Netherlands and is providing (credit) card payment services as an agent according to the service agreement concluded between iRubix N.V. and Chimp Bytes B.V. Skrill, Neteller, Paysafecard and Rapid Transfer transactions are processed by iRubix N.V."
                    )}
                  </div>
                  <div className="cryptocasinos_approved_logo">
                    <a target="_blank" href="">
                      <img
                        src={
                          require("assets/images/footer/cryptocasinos_approved_logo.svg").default
                        }
                      />
                    </a>
                  </div>
                </div>
              )}
            </div>
            <ul className="partner_footer_menu">
              <li>
                <a href="mailto:support@jokercasino.com">
                  <span className="partnerHeading">{__("Support")}:</span>{" "}
                  <span className="partnerText">support@jokercasino.com</span>
                </a>
              </li>
              <li>
                <a href="mailto:affiliates@jokercasino.com">
                  <span className="partnerHeading">{__("Partner")}: </span>{" "}
                  <span className="partnerText">
                    affiliates@jokercasino.com
                  </span>
                </a>
              </li>
              <li>
                <a href="mailto:info@jokercasino.com">
                  <span className="partnerHeading">{__("General")}:</span>{" "}
                  <span className="partnerText">info@jokercasino.com</span>
                </a>
              </li>
            </ul>
            <div className="footer_copyright">
              {/* <div className="curacao_license_area">
              <iframe
                style={{
                  width: "150px",
                  height: "50px",
                  border: "none",
                  marginLeft: "64px",
                  verticalAlign: "bottom",
                }}
                src="https://licensing.gaming-curacao.com/validator/?lh=e9f7b57748334a8ad515d52b96331ce4&template=tseal"
              ></iframe>
            </div> */}
              <div className="brands d-none d-lg-block">
                <ul>
                  <li className="dotIgamingLogo">
                    <a target="_blank" href="https://dot-igaming.com">
                      {/* ImageIx */}
                      <img
                        className="solidImg brand_img"
                        src={
                          require("../assets/images/common/dot-igaming-solid-white.svg").default
                        }
                      />
                      {/* <img
                        alt="Legal image"
                        src="https://chimpbytes.imgix.net/dot-igaming-solid-white.svg?&dpr=1&format=auto&auto=format&q=75&w=148&h=30&max-age=2629056"
                      /> */}
                      {/* ImageIx */}
                      <img
                        className="hoverImg brand_img"
                        src={
                          require("../assets/images/common/dot-igaming.svg").default
                        }
                      />
                      {/* <img
                        alt="Legal image"
                        src="https://chimpbytes.imgix.net/dot-igaming.svg?&dpr=1&format=auto&auto=format&q=75&w=148&h=30&max-age=2629056"
                      /> */}
                    </a>
                  </li>
                  <li>
                    <img
                      className="brand_img"
                      src={
                        require("../assets/images/footer/payop-logo-white.svg").default
                      }
                    />
                  </li>
                  <li>
                    <img
                      className="brand_img"
                      src={
                        require("../assets/images/brands/pragmatic.svg").default
                      }
                    />
                  </li>
                  <li>
                    <img
                      className="brand_img"
                      src={
                        require("../assets/images/brands/evolution.svg").default
                      }
                    />
                  </li>

                  <li>
                    <img
                      className="brand_img"
                      src={
                        require("../assets/images/brands/netent-logo.svg").default
                      }
                    />
                  </li>
                  <li>
                    <img
                      className="brand_img"
                      src={
                        require("../assets/images/brands/microgaming-logo.svg").default
                      }
                    />
                  </li>

                  <li>
                    {/* <img
                      className="brand_img"
                      src={
                        require("../assets/images/brands/hacksaw-gaming.png")
                      }
                    /> */}
                    <img
                      className="brand_img"
                      alt="game image"
                      src="https://chimpbytes.imgix.net/hacksaw-gaming.png?&dpr=1&format=auto&auto=format&q=50&w=91&h=30&max-age=2629056"
                    />
                  </li>
                  <li>
                    <a target="_blank" href="https://www.begambleaware.org">
                      <img
                        alt="game image"
                        src="https://chimpbytes.imgix.net/begambleawareorg_white.png?&dpr=1&format=auto&auto=format&q=50&w=173&h=23&max-age=2629056"
                      />
                    </a>
                  </li>
                  <li>
                    <a target="_blank" href="#">
                      <img
                        className="brand_img"
                        style={{ marginTop: "-10px", height: "35px" }}
                        src={
                          require("../assets/images/footer/new-brand.svg").default
                        }
                      />
                    </a>
                  </li>
                </ul>
              </div>

              <div className="footer_copyright_text">
                Copyright © {new Date().getFullYear()} www.jokercasino.com - All
                rights reserved.
              </div>
            </div>
            {/* <div className="copyright_text">
              copyright © {new Date().getFullYear()} JOKER CASINO - All Rights
              Reserved.
            </div> */}
          </div>
        </section>
      </footer>
      <CMSModal {...props} />
    </>
  );
};

export default Footer;
